import {Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy} from '@angular/core';
import {EntityTailConfig} from '../../../core/models/EntityTailConfig';
import {LegalEntity} from '../../../core/models/LegalEntity';
import * as _ from 'underscore';

@Component({
    selector: 'app-entity-tail-configs',
    templateUrl: './entity-tail-configs.component.html',
    styleUrls: ['./entity-tail-configs.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EntityTailConfigsComponent implements OnInit {

    @Input()
    entityTailConfigs: EntityTailConfig[];

    legalEntityList: LegalEntity[];

    constructor() {
    }

    ngOnInit() {
        this.legalEntityList = _.map(this.entityTailConfigs, x => x.legalEntity);
    }

    onCopyToAnotherEntity(value, index) {
        let foundIndex = -1;
        _.each(this.entityTailConfigs, (x, i) => {
            if (x.legalEntity.dataName === value) {
                foundIndex = i;
            }
        });

        if (foundIndex !== -1) {
            this.entityTailConfigs[foundIndex].yearRangeTails = this.entityTailConfigs[index].yearRangeTails.map(
                x => Object.assign({}, x));
        }
    }

}
